import { http } from "@/http";
import { SessionChannel } from "@/psychlab/types";

export const getStudyDataChannels = async(id:string):Promise<SessionChannel[]> => {
	const { data } = await http.get(`studies/${id}/channels`);
	return data;
};